import { render, staticRenderFns } from "./youtube.vue?vue&type=template&id=61889c3e&scoped=true&"
import script from "./youtube.vue?vue&type=script&lang=js&"
export * from "./youtube.vue?vue&type=script&lang=js&"
import style0 from "./youtube.vue?vue&type=style&index=0&id=61889c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61889c3e",
  null
  
)

export default component.exports